var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC8C15;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000127735858772586392560000011193732194030749578_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374,156c-76.1,0-138,61.9-138,138c0,18.6,3.7,36.9,11,54H144.2v-52c0-5.5-4.5-10-10-10s-10,4.5-10,10v62 c0,5.5,4.5,10,10,10h123.4c2.8,4.5,5.9,8.8,9.3,12.9c0.2,0.2,0.3,0.5,0.5,0.7L353.5,492h-46.9c-5.5,0-10,4.5-10,10s4.5,10,10,10 h135c5.5,0,10-4.5,10-10s-4.5-10-10-10h-47.2l86.7-111.1l0.1-0.1c19.9-24.6,30.7-55.2,30.7-86.8C512,217.9,450.1,156,374,156z  M465.5,368.5l-0.4,0.5L374,485.8l-90.2-115.6c-0.2-0.4-0.5-0.8-0.8-1.1c-41.5-50.3-34.4-124.6,15.9-166.1s124.6-34.4,166.1,15.9 C500.8,262.2,501,324.8,465.5,368.5L465.5,368.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452,270.8c-2-5.1-7.8-7.7-12.9-5.7c-4.7,1.8-7.3,6.9-6.1,11.8c10.5,32.6-7.4,67.5-40,78s-67.5-7.4-78-40 c-10.5-32.6,7.4-67.5,40-78c11.6-3.7,24-4,35.8-0.7c5.3,1.5,10.8-1.7,12.3-7c1.5-5.3-1.7-10.8-7-12.3 c-43.6-12.2-88.8,13.3-101,56.9c-12.2,43.6,13.3,88.8,56.9,101c43.6,12.2,88.8-13.3,101-56.9C457.4,302.5,457,286.1,452,270.8 L452,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.1,238.1L432,238c-3.8-4-10.2-4.1-14.1-0.2s-4.1,10.2-0.2,14.1c0.1,0.1,0.2,0.2,0.2,0.2l0.1,0.1 c3.8,4,10.2,4.1,14.1,0.2s4.1-10.2,0.2-14.1C432.3,238.3,432.2,238.2,432.1,238.1L432.1,238.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.3,420H10c-5.5,0-10,4.5-10,10s4.5,10,10,10h214.3v62c0,5.5,4.5,10,10,10s10-4.5,10-10v-72 C244.3,424.5,239.9,420,234.3,420z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.5,0c-5.5,0-10,4.5-10,10v72H10C4.5,82,0,86.5,0,92s4.5,10,10,10h172.5c5.5,0,10-4.5,10-10V10 C192.5,4.5,188,0,182.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,154H11c-5.5,0-10,4.5-10,10s4.5,10,10,10h65.8v174H11c-5.5,0-10,4.5-10,10s4.5,10,10,10h75.8 c5.5,0,10-4.5,10-10V164C96.8,158.5,92.4,154,86.8,154z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.2,253.9c-3.9-3.9-10.2-3.9-14.1,0c-3.9,3.9-3.9,10.2,0,14.1c3.9,3.9,10.2,3.9,14.1,0 c1.9-1.9,2.9-4.4,2.9-7.1C144.2,258.3,143.1,255.8,141.2,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,154H134.2c-5.5,0-10,4.5-10,10v55.5c0,5.5,4.5,10,10,10s10-4.5,10-10V174H256c5.5,0,10-4.5,10-10 S261.5,154,256,154z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,0c-5.5,0-10,4.5-10,10v72H240.8V10c0-5.5-4.5-10-10-10s-10,4.5-10,10v82c0,5.5,4.5,10,10,10H400 c5.5,0,10-4.5,10-10V10C410,4.5,405.5,0,400,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,82h-44V10c0-5.5-4.5-10-10-10s-10,4.5-10,10v82c0,5.5,4.5,10,10,10h54c5.5,0,10-4.5,10-10 S507.5,82,502,82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,154h-31.6c-5.5,0-10,4.5-10,10s4.5,10,10,10H502c5.5,0,10-4.5,10-10S507.5,154,502,154z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias);
export default __webpack_public_path__ + "static/media/Vias.1217a92447e656dbbd5bb3e61fb6b8a1.svg";
export { ForwardRef as ReactComponent };